import { combineReducers } from "redux";
import { createItemReducer } from "@mnjsplatform/data/lib/reducers/dataItemReducer";
/*
Отправить – PersOffAuth.SendPIN
Подтвердить – PersOffAuth.ConfirmPIN
Сбросить – PersOffAuth.ClearPIN
Проверить – PersOffAuth.CheckPINwithResult
*/
export function smsAuthReducer() {
    return combineReducers({
        PersOffAuth_SendPIN: createItemReducer("SMSAuth", "PersOffAuth.SendPIN", false),
        PersOffAuth_ConfirmPIN: createItemReducer("SMSAuth", "PersOffAuth.ConfirmPIN", false),
        PersOffAuth_ClearPIN: createItemReducer("SMSAuth", "PersOffAuth.ClearPIN", false),
        PersOffAuth_CheckPINwithResult: createItemReducer("SMSAuth", "PersOffAuth.CheckPINwithResult", false)
    });
}